// extracted by mini-css-extract-plugin
export var button = "volume-control-module--button--5dd35";
export var slider = "volume-control-module--slider--f9c3c";
export var sliderContainer = "volume-control-module--sliderContainer--23746";
export var volumeControl = "volume-control-module--volumeControl--8b57f";